import React, { Component } from 'react';
import { Row, Col } from 'antd';
import logo from '../../images/logomid.png';
import './LoginView.css';

class LoginView extends Component {
    constructor(props) {
        super(props);
        this.authWithEmailPassword = this.authWithEmailPassword.bind(this);
    }

    authWithEmailPassword(event) {
        event.preventDefault();
        const email = this.emailInput.value;
        const password = this.passwordInput.value;
        this.props.loginHandle(email, password);
    }

    render() {
        return (
            <div className="login-container">
                <div className="container">
                    <Row>
                        <Col className=" login-box">
                            <form className="form-signin login-form" onSubmit={(event) => { this.authWithEmailPassword(event); }} ref={(form) => { this.loginForm = form; }}>
                                <div className="login-logo">
                                    <img src={logo} alt="MID" width="250" />
                                </div>
                                <input type="email" id="inputEmail" className="form-control" placeholder="Email address" ref={(input) => { this.emailInput = input; }} required />
                                <input type="password" id="inputPassword" className="form-control" placeholder="Password" required="" ref={(input) => { this.passwordInput = input; }} />

                                <button className="btn btn-lg btn-primary btn-block" type="submit">
                                    Iniciar Sesión
                                </button>
                            </form>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}
export default LoginView;



// WEBPACK FOOTER //
// ./src/components/views/LoginView.js